import React, { FC, useState } from "react";
import { useDeleteIncidentMutation, useGetIncidentByOrderIdQuery } from "../productsApi";
import {formatIsoDateString} from "../../../helpers/utils/DateUtils";
import { useGetEnumsQuery } from "../../../app/globalApi";
import { getBooleanDisplayIcon } from "../../../helpers/utils/Utils";
import { FaCirclePlus } from "react-icons/fa6";
import ModalButton from "../../../components/common/form/ModalButton";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import IncidentModal from "../modal/AddOrEditIncident";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { getEnumDisplayNameByConstant } from "../../../helpers/utils/EnumUtils";
import IconButton from "../../../components/common/form/IconButton";
import {hasPermission} from "../../../helpers/utils/AccessControlUtils";

interface props {
    orderId?: string | null,
}
const Incident: FC<props> = ({ orderId }) => {

    const { data: incidents } = useGetIncidentByOrderIdQuery({ orderId: orderId });
    const { data: enums } = useGetEnumsQuery("");
    const [showModal, setShowModal] = useState<any>();
    const [incidentId, setIncidentId] = useState<any>();
    const [deleteIncident, { isLoading }] = useDeleteIncidentMutation();

    const handleDelete = async (incidentId: string) => {
        if (incidentId) {
            return await deleteIncident(incidentId).unwrap();
        }
    };
    const columns: DataTableColumn[] = [
        {
            label: "Product",
            accessor: "productType",
            canSort: false,
            cell: (props: any) => {
                const canEdit = hasPermission(["INCR-U"]);
                const className = `column-link active ${
                    canEdit ? "text-highlight-5 cursor-pointer" : "text-surface-0 cursor-default"
                }`;
                const handleClick = (e: React.MouseEvent) => {
                    if (!canEdit) return;
                    e.stopPropagation();
                    setIncidentId(props.row.original.id);
                    setShowModal(true);
                };
                return (
                    <span className={className} onClick={handleClick}>
                {getEnumDisplayNameByConstant(enums?.["ProductType"], props.value)}
            </span>
                );
            }
        },
        {
            label: "Type",
            accessor: "incidentType",
            canSort: false,
            cell: (props: any) => {
                return getEnumDisplayNameByConstant(enums?.IncidentType, props?.value)
            }
        },

        {
            label: "Severity",
            accessor: "severity",
            canSort: false,
            cell: (props: any) => {
                return getEnumDisplayNameByConstant(enums?.IncidentSeverity, props?.value)
            }
        },

        {
            label: "Date",
            accessor: "occurredDate",
            canSort: false,
            cell: (props: any) => {
                return formatIsoDateString(props.value);
            }
        },
        {
            label: "Claim",
            accessor: "claim",
            canSort: false,
            cell: (props: any) => {
                return getBooleanDisplayIcon(props?.value, "Enabled", "Disabled", '');
            }
        },
        {
            label: "Amount",
            accessor: "claimAmount",
            canSort: false,

        },
        {
            label: "Action",
            accessor: "delete",
            visibility: {
                canColumnShow: hasPermission(["INCR-D"]),
                showByDefault: hasPermission(["INCR-D"]),
                hasShowSetting: false,
            },
            canSort: false,
            cell: (props: any) => {
                return <>
                    <div className="ml-4">
                        <ModalButton
                            triggerButton={
                                <IconButton
                                    icon={<FaTrash />}
                                    title={"Delete Incident"}
                                    hasBackground={false}
                                    className="mr-2 text-highlight-0"
                                />}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => { }}
                                    title="Delete Incident"
                                    bodyMessage={`Are you sure you want to delete this incident?`}
                                    onSubmit={() => handleDelete(props.row.original.id)}
                                    isLoading={isLoading}
                                />
                            }
                        />
                    </div>
                </>
            }
        }
    ]

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md">
            <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                <h5 className="font-semibold text-surface-0">Incidents ({incidents?.length || 0})</h5>
                <ModalButton
                    modal={<IncidentModal show={true}
                        setShow={() => {
                        }}
                        title={"Add Incident"} btnText={"Add"}
                        orderId={orderId}
                    />}
                    triggerButton={
                        <FaCirclePlus
                            title={"Add Incident"}
                            className={`cursor-pointer text-md  !text-highlight-0`} />
                    }
                />
            </div>
            <div className="p-2">
                <div className="w-full bg-text-0 border-2 border-[rgba(0,0,0,0.1)]">
                    <DataTable
                        columns={columns}
                        actions={{
                            fetchAction: useGetIncidentByOrderIdQuery,
                        }}
                        defaultFilter={{
                            orderId: orderId
                        }}
                        appendFilterToUrl={false}
                        classname="bg-text-0 border-b-2 border-surface-5 font-medium"
                    />
                </div>
            </div>

            {
                showModal &&
                <IncidentModal show={showModal} setShow={setShowModal}
                    title={"Update Incident"} incidentId={incidentId} btnText={"Update"} orderId={orderId}
                />
            }
        </div>
    )
}

export default Incident;
